export default __webpack_public_path__ + "static/media/Workout-Pants.de6a6959.jpg";